<div class="mm-popup-wizard-footer"
     [class.mm-popup-wizard-footer-single-end-button]="!isBackVisible && isForwardVisible && !hasCustomContent">
    <app-popup-action-button
        (click)="navigateBackClicked.emit()"
        type="secondary"
        *ngIf="isBackVisible">
        {{backText}}</app-popup-action-button>
    <ng-content></ng-content>
    <app-popup-action-button
        (click)="navigateForwardClicked.emit()"
        *ngIf="isForwardVisible"
        [disabled]="isForwardDisabled">
        {{forwardText}}</app-popup-action-button>
</div>
